module.exports = __webpack_public_path__ + "static/fonts/CoHeadlineCorp-Regular.3934492.woff";